import { render } from "./ApiUsageResults.vue?vue&type=template&id=8bd258e8"
import script from "./ApiUsageResults.vue?vue&type=script&lang=js"
export * from "./ApiUsageResults.vue?vue&type=script&lang=js"
script.render = render

export default script